const requiredRule = { required: true, message: "This field is required!" };

export default requiredRule;
